import React, {useContext, useState} from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import Button from '../../components/elements/Button';
import Header from '../../components/elements/Header';
import Divider from '../../components/elements/Divider';
import Popup from '../../components/elements/Popup';
import Text from '../../components/elements/Text';
import MobilePhoneInput from '../../components/elements/MobilePhoneInput';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../theme';
import {BUTTON_TYPES, SEND_OTP_TYPES} from '../../utils/Constants';
import {
  DLog,
  getCountryCode,
  transformPhoneForAPI,
} from '../../utils/HelperMethods';
import {fetchApi} from '../../utils/ApiHelper';
import {HTTP_METHODS, SEND_OTP} from '../../utils/URLConstants';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';
import {errorStatusContext} from '../../contexts/ErrorStatusContext';
import CommonStyles from '../../utils/CommonStyles';
import UI from './ui';
import {tID} from '../../utils/TestIdHelper';
import {CloseIcon} from '../../utils/SvgIcons';

const ChangePhoneNumber = ({
  navigation,
  route,
  openPopup,
  onClosePopup = () => {},
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [hasError, setHasError] = useState(false);

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);

  const onPressVerify = () => {
    const postData = {
      phone: transformPhoneForAPI(phoneNumber),
      type: SEND_OTP_TYPES.changePhone,
    };

    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.POST, SEND_OTP, postData)
      .then(response => {
        lpc.setVisible(false);
        if (response.status == 200) {
          if (Platform.OS === 'web') {
            //closing change phone number popup and passing phone number to open verification popup
            onClosePopup(phoneNumber);
          } else {
            navigation.navigate('ChangePhoneNumberVerification', {
              phoneNo: phoneNumber,
            });
          }
        } else {
          //if OTP call fails due to any reason including an invalid phone number
          setHasError(true);
        }
      })
      .catch(error => {
        DLog(error);
        lpc.setVisible(false);
        setHasError(true);
        esc.showError(error);
      });
  };

  return (
    <UI openPopup={openPopup}>
      <SafeAreaView
        testID={tID('ChangePhoneNumber-SafeAreaView-Main')}
        style={[
          styles.screenBackground,
          Platform.OS === 'web' ? styles.webcontainer : CommonStyles.full_flex,
        ]}>
        <View
          testID={tID('ChangePhoneNumber-View-HeaderContainer')}
          style={[styles.headerView, {marginTop: 30}]}>
          <Header
            title="Change Phone Number"
            leftImage={<CloseIcon />}
          leftIconAccessibilityLabel="Close"
            onPressLeftIcon={navigation?.goBack}
            hideLeftIem={Platform.OS === 'web'}
          />
        </View>
        <ScrollView
          testID={tID('ChangePhoneNumber-ScrollView-1')}
          style={CommonStyles.full_flex}
          bounces={false}>
          <View style={styles.contentContainer}>
            <Text
              testID={tID('ChangePhoneNumber-Text-Description')}
              variation="Text1Regular"
              color={colors.textSecondary}>
              Please enter your new mobile number. You will need to verify your
              phone number via text.
            </Text>
            <Divider top={16} />
            <MobilePhoneInput
              topMargin={24}
              placeholder={'XXX-XXXX'}
              inputTitle={'Mobile Phone Number'}
              phoneNumber={phoneNumber}
              onChangePhoneNumber={setPhoneNumber}
              leftText={getCountryCode()}
              hasError={hasError}
            />
          </View>
        </ScrollView>
        <View
          testID={tID('ChangePhoneNumber-View-ButtonsContainer')}
          style={[styles.buttonContainer, {paddingBottom: 24}]}>
          {Platform.OS === 'web' ? (
            <Button
              testID={tID('ChangePhoneNumber-Button-Cancel')}
              style={[styles.button, CommonStyles.mr_16]}
              onPress={() => onClosePopup()}
              title={'Cancel'}
            />
          ) : null}
          <Button
            testID={tID('ChangePhoneNumber-Button-VerifyPhoneNumber')}
            disabled={phoneNumber.length === 0}
            buttonType={BUTTON_TYPES.Filled}
            titleColor={colors.textOnAccent}
            title={'Verify Phone Number'}
            onPress={onPressVerify}
            style={styles.button}
          />
        </View>
      </SafeAreaView>
    </UI>
  );
};

export default ChangePhoneNumber;
